/**
 * Who may delete a reservation outright. Mirrors lib/reservationDelete.js on
 * the server, which refuses anything else with a 409.
 *
 * Members (RM-439): a draft and nothing else, and never one that still carries
 * a card hold — a submitted request is removed with Rescinded or Canceled.
 *
 * RM Team (Kapil 11/1): any status. The server releases any card hold first and
 * refuses the delete if Stripe does not confirm the release; a charged hold and
 * an instant booking with a payment are never deleted.
 */
export const DELETABLE_STATUSES = ['Draft', '', null, undefined]

export function canDeleteReservation(reservation, { admin = false } = {}) {
  if (!reservation) return false
  if (admin) {
    if (reservation.stripeHoldCapturedAt || reservation.stripeHoldState === 'captured') return false
    if (reservation.reservationType === 'instant' && reservation.stripeHoldPaymentIntentId) return false

    return true
  }
  if (!DELETABLE_STATUSES.includes(reservation.status)) return false

  return !reservation.stripeHoldPaymentIntentId
}

/** What the admin's confirm dialog says before a delete. */
export function adminDeleteConfirmation(reservation) {
  if (!reservation || DELETABLE_STATUSES.includes(reservation.status)) {
    return 'Are you sure you want to delete this reservation? This is not reversible!'
  }
  const hold = reservation.stripeHoldPaymentIntentId ? ' Its card hold is released first; if Stripe does not confirm the release, nothing is deleted.' : ''
  const open = ['Submitted', 'Pending RM Review', 'Awaiting Response from Restaurant', 'In Review', 'Member Action'].includes(reservation.status)
  const notices = open ? ' The request is withdrawn: the member gets the rescind confirmation and a restaurant that has it is told to disregard it.' : ' No one is notified.'

  return `Delete this ${reservation.status} reservation for good?${hold}${notices} This is not reversible!`
}
